/*
 * Alexander Sachs : recherche restreinte au titre produit.
 * Chaque mot de la requete est prefixe par "title:" (ex. "linen short" -> "title:linen title:short").
 * Fallback : si la recherche par titre ne renvoie rien, la recherche normale est relancee.
 * Fichiers lies : snippets/as-title-search.liquid (redirection fallback page resultats).
 * Mise en place : 2026-11-04.
 */
(function () {
  'use strict';

  if (window.__asTitleSearch) return;
  window.__asTitleSearch = true;

  var PREFIX = 'title:';

  function toTitleQuery(raw) {
    if (typeof raw !== 'string') return raw;
    var trimmed = raw.trim();
    if (!trimmed || trimmed.indexOf(':') !== -1) return raw;
    return trimmed
      .split(/\s+/)
      .filter(Boolean)
      .map(function (word) { return PREFIX + word; })
      .join(' ');
  }

  function cleanTerms(text) {
    return String(text).replace(/title:/gi, '').replace(/\s+/g, ' ').trim();
  }

  function isSearchPath(pathname) {
    return /\/search(\/suggest(\.json)?)?\/?$/.test(pathname);
  }

  function isEmptyResponse(body) {
    if (body.indexOf('predictive-search__no-results') !== -1) return true;
    var first = body.trim().charAt(0);
    if (first === '{') {
      try {
        var json = JSON.parse(body);
        var results = json && json.resources && json.resources.results;
        if (!results) return false;
        for (var key in results) {
          if (Object.prototype.hasOwnProperty.call(results, key) && results[key] && results[key].length > 0) {
            return false;
          }
        }
        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  /* 1. Recherche predictive et rechargements AJAX : reecriture de q dans les appels fetch */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var method = (init && init.method ? init.method : 'GET').toUpperCase();
        var urlString = typeof input === 'string' ? input : (input instanceof URL ? input.href : null);
        if (urlString && method === 'GET') {
          var url = new URL(urlString, window.location.origin);
          if (url.origin === window.location.origin && isSearchPath(url.pathname)) {
            var raw = url.searchParams.get('q');
            var rewritten = toTitleQuery(raw);
            if (raw && rewritten !== raw) {
              url.searchParams.set('q', rewritten);
              return nativeFetch.call(window, url.toString(), init).then(function (response) {
                if (!response.ok) return response;
                return response.clone().text().then(function (body) {
                  if (!isEmptyResponse(body)) return response;
                  var fallback = new URL(url.toString());
                  fallback.searchParams.set('q', raw);
                  return nativeFetch.call(window, fallback.toString(), init);
                });
              });
            }
          }
        }
      } catch (e) {
        /* en cas de doute, comportement natif */
      }
      return nativeFetch.apply(window, arguments);
    };
  }

  /* 2. Soumission des formulaires de recherche (header, page resultats, bouton "voir tous les resultats") */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute('method') || 'GET').toUpperCase() !== 'GET') return;

    var action;
    try {
      action = new URL(form.action, window.location.href);
    } catch (e) {
      return;
    }
    if (action.origin !== window.location.origin || !isSearchPath(action.pathname)) return;

    var input = form.elements.namedItem('q');
    if (!input || typeof input.value !== 'string') return;

    var raw = input.value;
    var rewritten = toTitleQuery(raw);
    if (rewritten === raw) return;

    event.preventDefault();
    event.stopPropagation();

    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (typeof value === 'string') params.append(key, value);
    });
    params.set('q', rewritten);

    window.location.assign(action.pathname + '?' + params.toString());
  }, true);

  /* 3. Page resultats : masquer "title:" a l'affichage */
  function isTitleSearchPage() {
    try {
      var q = new URLSearchParams(window.location.search).get('q') || '';
      return isSearchPath(window.location.pathname) && /title:/i.test(q);
    } catch (e) {
      return false;
    }
  }

  function scrub(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && /title:/i.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(/title:/gi, '');
      }
    }
    var inputs = root.querySelectorAll ? root.querySelectorAll('input[name="q"]') : [];
    for (var i = 0; i < inputs.length; i++) {
      if (/title:/i.test(inputs[i].value)) inputs[i].value = cleanTerms(inputs[i].value);
    }
  }

  if (isTitleSearchPage()) {
    if (/title:/i.test(document.title)) document.title = document.title.replace(/title:/gi, '');

    var start = function () {
      scrub(document.body);
      if (/title:/i.test(document.title)) document.title = document.title.replace(/title:/gi, '');
      if (typeof MutationObserver === 'function') {
        new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              if (added[j].nodeType === 1) scrub(added[j]);
              else if (added[j].nodeType === 3 && /title:/i.test(added[j].nodeValue)) {
                added[j].nodeValue = added[j].nodeValue.replace(/title:/gi, '');
              }
            }
          }
        }).observe(document.body, { childList: true, subtree: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
})();
